/**
 * @name API 헤더 접근 서비스 ID
 * @param USER 회원&공통
 * @param COUPON 쿠폰
 * @param EVENT 이벤트
 * @param CLUB 클럽&입점사
 * @param PUSH 푸쉬
 * @param SCANGO 스캔앤고
 * @param PRODUCT 상품
 * @param BOTTLE 보틀벙커
 * @param LOG 로그
 */
export enum E_API_SERVICEID {
  'USER' = 'USER',
  'COUPON' = 'COUPON',
  'EVENT' = 'EVENT',
  'ASSISTANT' = 'ASSISTANT',
  'CLUB' = 'ASSISTANT',
  'PUSH' = 'PUSH',
  'SCANGO' = 'SCANGO',
  'PRODUCT' = 'PRODUCT',
  'BOTTLE' = 'BOTTLE',
  'LOG' = 'LOG',
}

/**
 * @name 점포 타입
 */
export enum E_STR_TYPE {
  'HYPER' = '1',
  'ZETTA' = '2',
  'MAXX' = '3',
  'SUPER' = '4',
}

/**  링크방식 구분
 * @name API
 * @param INSIDE 앱 내 링크
 * @param OUTSIDE 외부 링크
 * @param NONE 링크없음
 */
export enum E_LINK_KIND {
  'INSIDE' = '1',
  'OUTSIDE' = '2',
  'NONE' = '3',
}

/**
 * @name 팝업 열기/닫기 상태값
 * @param NONE 없음
 * @param OPEN 열기
 * @param CLOSE 닫기
 */
export enum E_POPUP_STATE {
  'OPEN' = 'OPEN',
  'CLOSE' = 'CLOSE',
  'NONE' = '',
}
